module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("分配学导记录")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配时间"
    }
  }, [_c('Row', [_c('Col', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.beginTimeChange
    }
  })], 1), _vm._v(" "), _c('Col', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeChange
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入id或学生名称"
    },
    model: {
      value: (_vm.queryParam.searchIdOrName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchIdOrName", $$v)
      },
      expression: "queryParam.searchIdOrName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "studyAdviserName"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.queryParam.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "adviserId", $$v)
      },
      expression: "queryParam.adviserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "原学导"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.oldAdminId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "oldAdminId", $$v)
      },
      expression: "queryParam.oldAdminId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "接收人"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "userStudyAdviser"
    },
    model: {
      value: (_vm.queryParam.receiverId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "receiverId", $$v)
      },
      expression: "queryParam.receiverId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 6,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配原因"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "reason", $$v)
      },
      expression: "queryParam.reason"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新生分配")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("服务原因更换")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "3"
    }
  }, [_vm._v("离职交接")])], 1)], 1)], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/distributionLearnRecord/page",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69c00f55","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/DistributionStudyRecord.vue
// module id = 1851
// module chunks = 8